import {
    array,
    enum as zodEnum,
    literal,
    number,
    object,
    string,
    TypeOf,
    union,
} from 'zod';

/* ----------------------------- UserPaymentType ---------------------------- */

export const UserPaymentType = zodEnum(['rental']);
export type UserPaymentType = TypeOf<typeof UserPaymentType>;

/* ---------------------------- UserPaymentStatus --------------------------- */

export const UserPaymentStatus = zodEnum([
    'requires-action',
    'success',
    'failed',
]);
export type UserPaymentStatus = TypeOf<typeof UserPaymentStatus>;

/* ---------------------------- RentalUserPayment --------------------------- */

export const RentalUserPayment = object({
    id: string(),
    created: string(),
    type: literal('rental'),
    price: number().optional(),
    currency: string().optional(),
    productId: string(),
});
export type RentalUserPayment = TypeOf<typeof RentalUserPayment>;

/* ------------------------- SubscriptionUserPayment ------------------------ */

export const SubscriptionUserPayment = object({
    id: string(),
    created: string(),
    type: literal('subscription'),
    status: UserPaymentStatus,
    price: number().optional(),
    currency: string(),
    subscriptionIds: array(string()),
});
export type SubscriptionUserPayment = TypeOf<typeof SubscriptionUserPayment>;

/* ------------------------------- UserPayment ------------------------------ */

export const UserPayment = union([RentalUserPayment, SubscriptionUserPayment]);
export type UserPayment = TypeOf<typeof UserPayment>;

/* --------------------------- UserPaymentResponse -------------------------- */

export const UserPaymentsResponse = object({
    data: array(UserPayment),
});
export type UserPaymentsResponse = TypeOf<typeof UserPaymentsResponse>;
